import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateManagePrescriptionSubmissionData } from "../../../../../actions/ManagePrescriptionAction";
import { getPatientDetails } from "../../../../../reducers/symptom.api";
import GenderPicker from "../../../../GenderPickerV2/GenderPicker";
import Incrementdecrementer from "../../../../Incrementdecrementer/Incrementdecrementer";
import DatePicker from "../../../../ManagePrescriptionComponents/DatePicket/DatePicker";
import PrescriptionDropDown from "../../../../PrescriptionDropdown/PrescriptionDropDown";
import { PrescriprionContext } from "../../../PrintPrescription";
import DetailsTab from "../DetailsTab";
import styles from "./patientdetails.module.scss";

function PatientDetails() {
  const dispatch = useDispatch();
  const { wholeData, handleWholeData } = useContext(PrescriprionContext);
  const submissionData = useSelector(
    (state) => state?.managePrescription?.submissionData
  );
  const [patientDetails, setPatientDetails] = useState([]);

  let appointmentHistoryRedux = useSelector(
    (state) => state.appointmentHistory.selectedAppointment
  );

  console.log('DataToPopulate', appointmentHistoryRedux?.[0])

  let rgx = /^[A-Za-z0-9]*$/;
  let nameReg = /^[A-Za-z\s]*$/;

  const handleChangeData = ({ key, value }) => {
    console.log("***value****",value)
    console.log("submissionData",submissionData)
    pushToWholeData(key, value);
    dispatch(
      updateManagePrescriptionSubmissionData({
        [key]: value,
      })
    );
  };

  let handleIdChange = (e) => {
    let { value } = e?.target;
    if (value.match(rgx) && value?.length <= 20) {
      handleChangeData({ key: "patient_id", value });
      pushToWholeData("patientId", value);
    }
  };

  let handleNameChange = (e) => {
    let { value } = e?.target;
    if (nameReg.test(value) && value?.length <= 20) {
      handleChangeData({ key: "patient_name", value });
      pushToWholeData("patientName", value);
    }
  };
const encryptedUrl = "GzvflBDHnO8avB6qc/YN/uqEcb9VlLay+po8i/PWYNEUJw4fcyDEcAGc+JQg7Z4sYLLiiZjK9G+REAz+DC19sKVmMevnQDjlOB0/d4I2zim19lbS2tAA1ldt8MqXQGFYQ3Hjni6ozj2uYtYNmr5/2e5iu2DAfR5Na5p9rNonT+aM64gCl6QdkIaXdx2F2zdtsoTFfY1rsWB4T/udUY6Pt05sSnQ749W7GDsCwZtjCiy5hWVkoCRaIJsjYAR0IBRXX6GnJuB5Y/gAeCGYDcC9POctA3VDcA6cLgU5NMmJAQP2glLehKp21pOEIzW1CLyoUC9DBzPzjmXH3+C09GmPcLcZt9JH4irsKjZu+gWefuM="

  useEffect(() => {
    getPatientDetails((res) => {
      (res.patientno && res.patientno!=="") && handleWholeData("patientId", res.patientno);
      (res.patientname && res.patientname!=="") && handleWholeData("patientName", res.patientname);
      (res.age && res.age!=="") && handleWholeData("patientAge", res.age);
      (res.gender && res.gender!=="") && handleWholeData("gender", res.gender);
      (res.appointmentID && res.appointmentID!=="") && handleWholeData("appointmentId", res.appointmentID);
      (res.doctorcode && res.doctorcode!=="") && handleWholeData("doctorCode", res.doctorcode);
      (res.qualification && res.qualification!=="") && handleWholeData("doctorQualification", res.qualification);
      (res.registrationnumber && res.registrationnumber!=="") && handleWholeData("registrationNumber", res.registrationnumber);
      (res.doctorname && res.doctorname!=="") && handleWholeData("doctorName", res.doctorname);
      (res.doctorname && res.appointmentdate!=="") && handleWholeData("appointmentdate", res.appointmentdate);
      (res.doctorname && res.appointmenttime!=="") && handleWholeData("appointmenttime", res.appointmenttime);
      setPatientDetails(res);
    });
  }, []);

  const pushToWholeData = (key, data) => {
    handleWholeData(key, data);
  };

  console.info("wholeData",wholeData?.heightValue.length)

  const displayName = appointmentHistoryRedux?.[0]?.appointmentFor === "Loved One"
  ? appointmentHistoryRedux?.[0]?.appointmentForName
  : appointmentHistoryRedux?.[0]?.patientName;

  return (
    <div className={styles.container}>
      <div className={styles.formItem}>
        <div className={styles.caption}>Patient ID</div>
        <div className={styles.item}>
          <input
            maxLength={20}
            value={appointmentHistoryRedux?.[0].patientId || ""}
            placeholder="Type here"
            onChange={handleIdChange}
            className={styles.input}
            disabled
            type="text"
          />
        </div>
      </div>

      <div className={styles.formItem}>
        <div className={styles.caption}>Patient Name</div>
        <div className={styles.item}>
          <input
            value={displayName || ""}
            placeholder="Type here"
            onChange={handleNameChange}
            className={styles.input}
            disabled
          />
        </div>
      </div>

      <div className={styles.formItem}>
        <div className={styles.caption}>Age</div>
        <div className={styles.item}>
          <input
            disabled
            value={appointmentHistoryRedux?.[0].patientDetails?.personalDetails?.age || ""}
            placeholder="Type here"
            onChange={handleNameChange}
            className={styles.input}
          />
        </div>
      </div>

      <div className={styles.formItem}>
        <div className={styles.caption}>Gender</div>
        <div className={styles.item}>
          <GenderPicker
            disabled
            value={submissionData?.gender}
            onChange={(value) => {
              handleChangeData({ key: "gender", value });
            }}
          />
        </div>
      </div>

      <div className={styles.formItem}>
        <div className={styles.caption}>
          Height{" "}
          <span className={styles.captionLight}>(whenever applicable)</span>
        </div>
        <div className={styles.item}>
          <div className={styles.height_weight_container}>
            <Incrementdecrementer
              disabled={false}
              value={wholeData?.heightValue}
              onChange={(value) => {
                handleChangeData({ key: "heightValue", value });
              }}
            />

            <PrescriptionDropDown
              value={wholeData?.heightMessurment}
              onChange={(value) => {
                handleChangeData({ key: "heightMessurment", value });
              }}
              defaultPlaceH={"Select one"}
              defaultValue={"Select one"}
              DataItem={["cm", "ft", "in"]}
              
            />
          </div>
        </div>
      </div>

      <div className={styles.formItem}>
        <div className={styles.caption}>
          Weight{" "}
          <span className={styles.captionLight}>(whenever applicable)</span>{" "}
        </div>
        <div className={styles.item}>
          <div className={styles.height_weight_container}>
            <Incrementdecrementer
              disabled={false}
              value={wholeData?.weightValue}
              onChange={(value) => {
                handleChangeData({ key: "weightValue", value });
              }}
            />

            <PrescriptionDropDown
              value={wholeData?.weightMessurment}
              
              onChange={(value) => {
                handleChangeData({ key: "weightMessurment", value });
              }}
              defaultPlaceH={"Select one"}
              defaultValue={"Select one"}
              DataItem={["kg", "lbs"]}
            />
          </div>
        </div>
      </div>

      <div className={styles.formItem}>
        <div className={styles.caption}>
          LMP <span className={styles.captionLight}>(whenever applicable)</span>
        </div>
        <div className={styles.item}>
          
          <DatePicker
            disableFuture
            value={wholeData?.lmp || ""}
            onChange={(m, d) => {
              console.log("m",m)
              if(m!=null){
                handleChangeData({ key: "lmp", value:  moment(new Date(m)).format("DD-MMM-YYYY") });
              }else
              {
                handleChangeData({ key: "lmp", value: "" });
              }
            
            }}
            allowClear
          />
        </div>
      </div>
      <div className={styles.formItem}>
        <div className={styles.caption}>
          Diet 
        </div>
        <div className={styles.item}>
        <div className={styles.diet_container}>
        <PrescriptionDropDown
              value={wholeData?.diet}
              onChange={(value) => {
                handleChangeData({ key: "diet", value });
              }}
              //defaultValue={"Select diet"}
              DataItem={["Breast Feeds","Regular","Salt restricted diet","Diabetic diet","Liquid diet","Soft diet","CKD diet","Low fat low salt","High carbohydrate diet","Low potassium diet","Fat free diet"]}
              className="diet-drop"
              defaultPlaceH={"Select diet"}
            />
        
        </div>
        </div>
      </div> 
    </div>
  );
}

export default PatientDetails;

